export * from './isMobile';
export { default } from './isMobile';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ismobilejs/esm/index.js
// module id = 410
// module chunks = 52 53